import React from "react";
import Helmet from "react-helmet";
import {graphql} from "gatsby";
import config from "../../data/SiteConfig";
import "../layout/index.scss";
import Header from "../components/Header/Header";
import Left from "../components/Left/Left";
import Right from "../components/Right/Right";
import SEO from "../components/SEO/SEO";
import PostListing from "../components/PostListing/PostListing";

export default function Index({data}) {
  const postEdges = data.allMarkdownRemark.edges;
  const type = "page";
  return (
    // eslint-disable-next-line react/jsx-filename-extension
    <>
      <Helmet>
        <title>Hỏi đáp trực tuyến</title>
        <meta name="google-site-verification" content="8VWyTzERLUHa2pkSP2qIQqZtdfTkhVNVUG1i5J_0dY0" />
        <meta name="description" content={config.siteDescription} />
        <html lang="vi" />
      </Helmet>
      <SEO />
      <Header />
      <div className="container-z-c1-layout">
        <div className="container-z-c1-layout-col-1">
          <Left />
        </div>
        <div className="container-z-c1-layout-col-2">
          <article>
            <PostListing postEdges={postEdges} type={type} />
          </article>
        </div>
        <div className="container-z-c1-layout-col-3">
          <Right />
        </div>
      </div>
      <footer />
    </>
  );
}

export const query = graphql`
  query {
    allMarkdownRemark(sort: { order: DESC, fields: [frontmatter___date] }) {
      edges {
        node {
          excerpt(pruneLength: 250)
          id
          html
          frontmatter {
            title
            author
            category
            tags
            slug
            date
          }
        }
      }
    }
  }
`;
